import React from 'react';
import DataTable from '../../../components/DataTable';

function CandidateApplications(props) {

    let columns = ["name", "job_name", "company", "status"];
    let headers = ["Candidate", "Job Name", "Company", "Status"];

    return (
        <DataTable
            title="Candidate Applications"
            header={headers}
            url="can-applyjob/"
            filters='fields=id,name,job_name,company,status'
            column={columns}
            approve="ap"
            approve_label="status"
            status={["Approved", "Interview Scheduled", "Rejected"]}
            edit={false}
        />
    );
}

export default CandidateApplications;